import * as React from 'react'
import { Box, Typography } from 'cs-kevlar-react'
import {
  makeStyles,
  createStyles,
  Theme,
} from 'cs-kevlar-react/lib/es/theming/theme'
import clsx from 'clsx'

type Orientation = 'vertical' | 'horizontal'

type KeyValueTextProps = {
  label: string
  className?: string
  labelClassName?: string
  valueClassName?: string
  children?: any
  orientation?: Orientation
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    key: {
      fontWeight: 600,
    },
    rightMargin: {
      marginRight: theme.spacing(2),
    },
  }),
)

export const KeyValueText: React.FunctionComponent<KeyValueTextProps> = ({
  label,
  className,
  labelClassName,
  valueClassName,
  children,
  orientation = 'vertical',
}) => {
  const classes = useStyles({})
  const display = orientation === 'horizontal' ? 'inline' : 'block'
  return (
    <Box className={className}>
      <Typography
        className={clsx(
          classes.key,
          {
            [classes.rightMargin]: display === 'inline',
          },
          labelClassName,
        )}
        display={display}
      >
        {label}
      </Typography>
      {!children && (
        <Typography className={valueClassName} display={display}>
          --
        </Typography>
      )}
      {!!children && typeof children !== 'function' && (
        <Typography className={valueClassName} display={display}>
          {children}
        </Typography>
      )}
      {!!children && typeof children === 'function' && children()}
    </Box>
  )
}
